<!-- eslint-disable vue/multi-word-component-names -->
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import QuestionAnswer from '/src/components/QuestionAnswer.vue'
import QuestionPage from '/src/components/QuestionPage.vue'
import { MDBBtn} from "mdb-vue-ui-kit";
import { mapFields } from 'vuex-map-fields';

export default {
  components: {
    QuestionAnswer,
    QuestionPage,
    MDBBtn,
  },
  computed: {
    ...mapFields([
      'scene.status.communications'
    ]),
    ...mapGetters([
      'getQuestionAnswerData'
    ]),
    questionAnswerData() {
      return this.getQuestionAnswerData('communications')
    }
  },
  methods: {
    ...mapMutations([
      'selectCommunicationsStatus',
      'goToNextPage',
      'moveToItem'
    ]),
    ...mapActions([
      'goToItem',
    ]),
    chooseBasic: function () {
      this.selectCommunicationsStatus(1);
      this.communications = 1
    },
    chooseMedium: function () {
      this.selectCommunicationsStatus(2);
      this.communications = 2
    },
    chooseTop: function () {
      this.selectCommunicationsStatus(3);
      this.communications = 3
    }
  },
};
</script>
<template>
  <QuestionPage :title="questionAnswerData.question">
    <Transition name="switch" mode="out-in" appear>
      <div v-if="communications < 2 "
        class="question_image question_image_communications_minimum d-block d-sm-none"
      ></div>
      <div v-else-if="communications == 2"
        class="question_image question_image_communications_medium d-block d-sm-none"
      ></div>
      <div v-else-if="communications == 3"
        class="question_image question_image_communications_top d-block d-sm-none"
      ></div>
    </Transition>

    <!-- show on desktop only -->
    <QuestionAnswer
      :title='questionAnswerData.answers.A'
      class='d-none d-sm-block'
      :onSelect="chooseBasic"
      @click="goToItem('communications')"
      :imageName="questionAnswerData.images.Q3AA"
    />
    <QuestionAnswer
      :title='questionAnswerData.answers.B'
      class='d-none d-sm-block'
      :onSelect="chooseMedium"
      @click="goToItem('communications')"
      :imageName="questionAnswerData.images.Q3AB"
    />
    <QuestionAnswer
      :title='questionAnswerData.answers.C'
      class='d-none d-sm-block'
      :onSelect="chooseTop"
      @click="goToItem('communications')"
      :imageName="questionAnswerData.images.Q3AC"
    />

    <!-- on mobile only -->
    <div class='d-flex d-sm-none questions-on-mobile'>
      <QuestionAnswer
        :title='questionAnswerData.answers.A'
        :isSelected="communications == 1"
        :onSelect="chooseBasic"
      />
      <QuestionAnswer
        :title='questionAnswerData.answers.B'
        :isSelected="communications == 2"
        :onSelect="chooseMedium"
      />
      <QuestionAnswer
        :title='questionAnswerData.answers.C'
        :isSelected="communications == 3"
        :onSelect="chooseTop"
      />
      <MDBBtn class="next-btn-on-mobile" @click="moveToItem('communications')">next</MDBBtn>
    </div>

  </QuestionPage>
</template>


